var _defs, _rect, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPayMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_18_15",
    "data-name": "Component 18 \\u2013 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0a13d"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: "141px",
    height: "141px",
    rx: 70,
    transform: "translate(15 15)",
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8869",
    "data-name": "Path 8869",
    d: "M85,0h1a85,85,0,0,1,0,170H85A85,85,0,0,1,85,0Z",
    opacity: 0,
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_empty-wallet",
    "data-name": "vuesax/outline/empty-wallet",
    transform: "translate(-184.679 -137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-wallet",
    transform: "translate(236 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.136,33.789A2.152,2.152,0,0,1,0,31.653V18.637a10.336,10.336,0,0,1,6.636-9.6L29.252.493a7.456,7.456,0,0,1,6.95.855,7.53,7.53,0,0,1,3.247,6.209V18.38a2.136,2.136,0,1,1-4.272,0V7.557a3.25,3.25,0,0,0-1.424-2.706,3.183,3.183,0,0,0-3.019-.37L8.118,13.026a6.051,6.051,0,0,0-3.874,5.611V31.653A2.092,2.092,0,0,1,2.136,33.789Z",
    transform: "translate(4.984 3.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.325,15.95A8.2,8.2,0,0,1,.036,8.659,7.818,7.818,0,0,1,2.372,2.307,7.767,7.767,0,0,1,7.954,0h5.924a5.057,5.057,0,0,1,4.984,5.041v5.868a5.041,5.041,0,0,1-4.9,5.041Zm5.5-11.678H7.983A3.5,3.5,0,0,0,5.419,5.326,3.587,3.587,0,0,0,4.309,8.288a3.969,3.969,0,0,0,4.016,3.389h5.583a.756.756,0,0,0,.712-.769V5.041A.791.791,0,0,0,13.822,4.272Z",
    transform: "translate(47.501 34.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M22.074,4.272H2.136A2.152,2.152,0,0,1,0,2.136,2.152,2.152,0,0,1,2.136,0H22.074A2.152,2.152,0,0,1,24.21,2.136,2.152,2.152,0,0,1,22.074,4.272Z",
    transform: "translate(17.802 32.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H68.358V68.358H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M45.544,44.86h-32.7A12.849,12.849,0,0,1,0,32.015V12.846A12.849,12.849,0,0,1,12.846,0h32.7A12.849,12.849,0,0,1,58.39,12.846v4.1a2.152,2.152,0,0,1-2.136,2.136H50.5a3.5,3.5,0,0,0-2.563,1.054l-.028.029a3.6,3.6,0,0,0-1.082,2.905,3.969,3.969,0,0,0,4.016,3.389h5.412A2.152,2.152,0,0,1,58.39,28.6v3.389A12.855,12.855,0,0,1,45.544,44.86ZM12.846,4.272a8.582,8.582,0,0,0-8.573,8.573V32.015a8.582,8.582,0,0,0,8.573,8.573h32.7a8.582,8.582,0,0,0,8.573-8.573V30.761H50.842a8.2,8.2,0,0,1-8.288-7.292A8.018,8.018,0,0,1,50.5,14.811h3.617V12.846a8.582,8.582,0,0,0-8.573-8.573Z",
    transform: "translate(4.984 19.938)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayMoney);
export default __webpack_public_path__ + "static/media/payMoney.1ac965564157655b0bafc126fdc0bd5f.svg";
export { ForwardRef as ReactComponent };